import type { JDSSegmentedRingItemProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSSegmentedRingItemProps>
  ): React.FC<JDSSegmentedRingItemProps> =>
  (props: JDSSegmentedRingItemProps) => {
    return <Component {...props} />;
  };
